import React, { useLayoutEffect, useRef } from 'react';

// A textarea that grows to fit its content instead of clipping/scrolling. The
// height is recomputed whenever `value` changes (and on mount) so a prefilled
// template is shown in full without the user having to scroll or drag-resize.
export default function AutoGrowTextarea({ value, className, ...props }) {
    const ref = useRef(null);

    useLayoutEffect(() => {
        const el = ref.current;
        if (!el) {
            return;
        }
        el.style.height = 'auto';
        el.style.height = `${el.scrollHeight}px`;
    }, [value]);

    return (
        <textarea
            ref={ref}
            className={className}
            value={value}
            style={{ overflow: 'hidden', resize: 'none' }}
            {...props}
        />
    );
}
